import { isEqual, uniqWith } from 'lodash-es';

export interface ValidationResponse {
    Valid: boolean;
    Type?: ValidationResponseType;
    Errors: ValidationError[];
}

export interface ValidationError {
    Type: ValidationErrorType;
    Message?: string;
    Field: string; // DottedKey
    Code?: string;
}

export const enum ValidationErrorType {
    RequiredParameter = 'REQUIRED_PARAMETER',
    InvalidParameter = 'INVALID_PARAMETER',
    Global = 'GLOBAL'
}

export const enum ValidationResponseType {
    MissingRequiredFields = 'MissingRequiredFields'
}

export function createValidationResponse(
    invalidFieldDottedKeys: string[],
    type?: ValidationResponseType
): ValidationResponse {
    const validationErrors: ValidationError[] = invalidFieldDottedKeys.map(key => ({
        Type: ValidationErrorType.RequiredParameter,
        Field: key
    }));

    return {
        Valid: validationErrors.length === 0,
        Type: type,
        Errors: validationErrors
    };
}

export function mergeValidationResponses(validations: ValidationResponse[]): ValidationResponse {
    const validationErrors: ValidationError[] = validations.flatMap(validation => validation.Errors);
    const uniqueErrors: ValidationError[] = uniqWith(validationErrors, isEqual);

    return {
        Valid: uniqueErrors.length === 0,
        Type: ValidationResponseType.MissingRequiredFields,
        Errors: uniqueErrors
    };
}
